import { useLanguage } from '../context/LanguageContext';
import { getTranslation } from '../translations/translations';

const TestimonialsSection = () => {
  const { language } = useLanguage();
  const testimonials = [
    {
      quoteKey: "testimonialsSection.testimonial1",
      nameKey: "testimonialsSection.testimonial1Name",
      roleKey: "testimonialsSection.testimonial1Role",
      avatar: "SP",
    },
    {
      quoteKey: "testimonialsSection.testimonial2",
      nameKey: "testimonialsSection.testimonial2Name",  
      roleKey: "testimonialsSection.testimonial2Role",  
      avatar: "AD",
    },
    {
      quoteKey: "testimonialsSection.testimonial3",
      nameKey: "testimonialsSection.testimonial3Name",  
      roleKey: "testimonialsSection.testimonial3Role",  
      avatar: "RK",
    },
    {
      quoteKey: "testimonialsSection.testimonial4",
      nameKey: "testimonialsSection.testimonial4Name",
      roleKey: "testimonialsSection.testimonial4Role",
      avatar: "MK",
    },
  ];

  return (
    <section className="section-padding testimonials-section" id="testimonials">
      <div className="container">
        <div className="section-title" data-aos="fade-up">
          <h2>{getTranslation(language, 'testimonialsSection.title')}</h2>
          <p>
            {getTranslation(language, 'testimonialsSection.subtitle')}
          </p>
        </div>

        <div
          id="testimonialCarousel"
          className="carousel slide"
          data-bs-ride="carousel"
          data-aos="fade-up"
        >
          <div className="carousel-inner">
            {testimonials.map((testimonial, index) => (
              <div
                key={index}
                className={`carousel-item ${index === 0 ? "active" : ""}`}
              >
                <div className="row justify-content-center">
                  <div className="col-lg-8">
                    <div className="testimonial-card">
                      <div className="quote-icon">
                        <i className="bi bi-quote"></i>
                      </div>
                      <p>"{getTranslation(language, testimonial.quoteKey)}"</p>
                      <div className="testimonial-author">
                        <div
                          className="rounded-circle d-flex align-items-center justify-content-center me-3"
                          style={{
                            width: "60px",
                            height: "60px",
                            background: "var(--bg-gradient)",
                            color: "#fff",
                            fontWeight: "bold",
                            fontSize: "1.25rem",
                          }}
                        >
                          {testimonial.avatar}
                        </div>
                        <div className="text-start">
                          <h6>{getTranslation(language, testimonial.nameKey)}</h6>
                          <span>{getTranslation(language, testimonial.roleKey)}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <button
            className="carousel-control-prev"
            type="button"
            data-bs-target="#testimonialCarousel"
            data-bs-slide="prev"
            style={{ 
              width: '50px', 
              height: '50px', 
              left: '-70px',
              backgroundColor: 'var(--primary-color)',
              borderRadius: '50%',
              border: 'none',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <i className="bi bi-chevron-left" style={{ fontSize: '1.5rem', color: 'white' }}></i>
            <span className="visually-hidden">Previous</span>
          </button>
          <button
            className="carousel-control-next"
            type="button"
            data-bs-target="#testimonialCarousel"
            data-bs-slide="next"
            style={{ 
              width: '50px', 
              height: '50px', 
              right: '-70px',
              backgroundColor: 'var(--primary-color)',
              borderRadius: '50%',
              border: 'none',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <i className="bi bi-chevron-right" style={{ fontSize: '1.5rem', color: 'white' }}></i>
            <span className="visually-hidden">Next</span>
          </button>
          
          <div className="carousel-indicators position-relative mt-4">
            {testimonials.map((_, index) => (
              <button
                key={index}
                type="button"
                data-bs-target="#testimonialCarousel"
                data-bs-slide-to={index}
                className={index === 0 ? "active" : ""}
                aria-current={index === 0 ? "true" : undefined}
                aria-label={`Slide ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
